export { default } from "./ContentWarning";
